module.exports = __webpack_public_path__ + "static/img/yoyo.fbd2a3d3.svg";